import { Entity, Field } from "typegraph";

import CountResult from "./CountResult";

@Entity({one: "organization", many: "organizations"})
export default class Organization {

	@Field()
	public id: string;

	@Field()
	public guid: string;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field()
	public learnerPageAccess: boolean;

	@Field()
	public logoURL: string;

	@Field({entity: CountResult})
	public userCount: CountResult;

	@Field({entity: CountResult})
	public entryCount: CountResult;

}



// WEBPACK FOOTER //
// ./src/panels/organizationParticipant/entities/Organization.ts